export const aboutHero = {
  name: '华辉数智技术',
  en: 'HUAHUI DIGITAL INTELLIGENCE',
  subtitle: '人工智能应用服务 · 乡村数字经济 · 县域数字商业基础设施',
  desc: '华辉数智技术是一家面向县域与乡村场景的人工智能应用服务与数字商业基础设施服务商。我们以人工智能应用、数字商业基础设施和产业数字化技术，参与建设九畴云市乡村数字经济服务体系。',
};

export const positioning = [
  {
    icon: 'ri-robot-2-line',
    title: '人工智能应用服务商',
    tag: '交付实施类',
    desc: '聚焦县域与乡村场景的 AI 应用交付，覆盖咨询规划、交付实施、运营管理与安全治理全周期。',
  },
  {
    icon: 'ri-store-2-line',
    title: '数字商业基础设施方',
    tag: '系统实现',
    desc: '以数字货架、云铺系统为核心，为县域商业提供可复制、可运营的数字商业基础设施。',
  },
  {
    icon: 'ri-community-line',
    title: '乡村数字经济共建者',
    tag: '产业数字化',
    desc: '连接人、货、店、场、数据与消费，推动农产品上行与县域商业数字化升级。',
  },
];

export const relationshipSteps = [
  {
    icon: 'ri-building-2-line',
    title: '华辉数智技术',
    sub: '技术服务主体',
    desc: '承担核心技术系统的研发、交付与系统集成。',
  },
  {
    icon: 'ri-flow-chart',
    title: '技术交付与系统实现',
    sub: '研发 · 集成 · 部署 · 运维',
    desc: 'TOMA 智能体 + 数字货架 + 车载卡 + 系统开发。',
  },
  {
    icon: 'ri-rocket-2-line',
    title: '九畴云市',
    sub: '核心战略项目',
    desc: '乡村数字经济操作系统。',
  },
];

export const capabilityCards = [
  {
    icon: 'ri-robot-2-line',
    title: 'AI 应用',
    desc: 'TOMA 智能体',
    detail: 'AI 交互入口，美食社交、健康管家、数字服务。',
  },
  {
    icon: 'ri-store-2-line',
    title: '数字商业',
    desc: '数字货架 / 云铺系统',
    detail: '商品数字化、交易入口、数据回流。',
  },
  {
    icon: 'ri-router-line',
    title: 'IoT 连接',
    desc: '车载卡 / 智联设备',
    detail: '一物一码、设备接入、物联协同。',
  },
  {
    icon: 'ri-dashboard-3-line',
    title: '系统集成',
    desc: '平台 / 接口 / 数据看板',
    detail: '平台对接、接口开发、数据可视化。',
  },
];

export const serviceChain = ['研发', '集成', '部署', '运维'];

export const qualifications = [
  {
    icon: 'ri-file-list-3-line',
    title: '企业主体资质',
    desc: '依法登记注册的企业法人主体，具备技术服务与系统交付资质。',
  },
  {
    icon: 'ri-verified-badge-line',
    title: '人工智能应用服务商',
    tag: '规划申报',
    desc: '面向工信厅科函〔2026〕414 号方向，推进人工智能应用服务商入库与认定。',
  },
  {
    icon: 'ri-team-line',
    title: '服务团联合单位',
    tag: '生态协同',
    desc: '列入人工智能应用服务团联合单位，承担智能体、数字货架、系统集成与设备生产。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '技术成果',
    desc: 'TOMA 智能体、数字货架、数据看板、车载卡激活系统等核心技术交付。',
  },
];

export const ecosystem = [
  { name: '慈商科技', role: '产业运营协同' },
  { name: '三明词元', role: 'AI 模型与词元服务' },
  { name: '华辉数智技术', role: '技术交付与系统实现', highlight: true },
  { name: '纽盾科技', role: '安全治理与合规' },
  { name: '欣阳通力', role: '设备生产与供应链' },
];